import React from "react";

export default function footer(){

    return  <footer>&#169; 2023 #VANLIFE</footer>
}